import React, { Component } from 'react'

import OgaTable from "components/OgaTables/OgaTable";

import { connect } from "react-redux";

import moment from "moment";

import history from 'routes/History/history';

import {
    fetchDisbursementRequests,
    updateFilterStatus,
    updateFilterStartDate,
    updateFilterEndDate
} from "reducers/disbursementrequest/disbursementrequestActions";

import { Row, Col, FormGroup, Button } from "react-bootstrap";
import DatetimeRangePicker from 'react-datetime-range-picker';

import DisbursementRequestStatusSelect from 'components/DisbursementRequestStatusSelect/DisbursementRequestStatusSelect';
import NoInfo from 'components/NoInfo/NoInfo';

import DisbursementHistoryModal from "components/DisbursementHistoryModal/DisbursementHistoryModal";
import ConfirmModal from "components/ConfirmModal/ConfirmModal";

import { fetchDisbursementHistory, doAnnulment } from "reducers/disbursementrequest/disbursementrequestActions";

class DisbursementRequestList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            quantityRows: 10,
            showHistoryModal: false,
            disbursementId: null,
            loadingHistory: true,
            loadingAnnulment: false,
            showAnnulmentModal: false
        };
    }

    componentWillMount() {        
        this.loadDisbursementRequests(1, null, this.props.filterStartDate, this.props.filterEndDate);
    }

    loadDisbursementRequests(pageNumber, status, startDate, endDate) {
        this.setState({ loading: true });
        let promise = new Promise((resolve, reject) => {
            let requestData = {
                quantityRows: this.state.quantityRows,
                pageNumber: pageNumber,
                status: status,
                startDate: startDate === "" ? null : startDate,
                endDate: endDate === "" ? null : endDate
            }

            this.props.fetchDisbursementRequests(requestData, resolve, reject);
        });
        promise.then(() => {
            this.setState({ loading: false });
        });
    }

    handleStatusChange(status) {
        let value = status != null ? status.value : null;
        this.props.updateFilterStatus(value);
        this.loadDisbursementRequests(1, value, this.props.filterStartDate, this.props.filterEndDate);
    }

    handleStartDateChange(date) {
        console.log("handleStartDateChange", date);
        let value = typeof date === 'string' ? "" : moment(date).format('DD/MM/YYYY');
        this.props.updateFilterStartDate(value);

        this.loadDisbursementRequests(1, this.props.status, value, this.props.filterEndDate);
    }

    handleEndDateChange(date) {
        let value = typeof date === 'string' ? null : moment(date).format('DD/MM/YYYY');
        this.props.updateFilterEndDate(value);
        this.loadDisbursementRequests(1, this.props.status, this.props.filterStartDate, value);
    }

    onPageChange = (pageNumber) => {
        this.loadDisbursementRequests(pageNumber + 1, this.props.status, this.props.filterStartDate, this.props.filterEndDate);
    }

    goToNewDisbursementRequest() {
        history.push("/create-disbursement");
    }

    handleShowHistory = (row) => {
        console.log("handleShowHistory");
        this.setState(
            {
                showHistoryModal: true
            }
        );
        this.loadHistory(row.id);
    }

    handleAnnulment = (row) => {
        this.setState({
            disbursementId: row.id,
            showAnnulmentModal: true
        });
    }

    handleShowAnnulment = (row) => {
        return row.status === 'APPROVAL_PENDING';
    }

    loadHistory(disbursementId) {
        this.setState({ loadingHistory: true });
        let promise = new Promise((resolve, reject) => {
            this.props.fetchDisbursementHistory(disbursementId, resolve, reject);
        });

        promise.then(
            () => {
                this.setState({ loadingHistory: false });
            },
            () => {
                this.setState({ loadHistory: false });
            });
    }

    annul = (disbursementId) => {

        console.log("annul", disbursementId);

        this.setState({ loadingAnnulment: true });
        let promise = new Promise((resolve, reject) => {
            this.props.doAnnulment(disbursementId, resolve, reject);
        });

        promise.then(
            () => {
                this.setState({ loadingAnnulment: false, showAnnulmentModal: false });
                this.loadDisbursementRequests(1, this.props.status, this.props.filterStartDate, this.props.filterEndDate);
            },
            () => {
                this.setState({ loadingAnnulment: false, showAnnulmentModal: false });
            }
        );
    }

    render() {
        return (
            <div>

                <div>
                    <Row>
                        <Col md={4}>
                            <FormGroup >
                                <DisbursementRequestStatusSelect
                                    selection={this.props.filterStatus}
                                    handleChange={(status) => this.handleStatusChange(status)}
                                />
                            </FormGroup >
                        </Col>
                    </Row>

                    <FormGroup >
                        <DatetimeRangePicker
                            dateFormat={"DD/MM/YYYY"}
                            inputProps={{ className: "form-control form-control-sm", placeholder: "Seleccione rango de fechas" }}
                            onChange={this.handler}
                            timeFormat={false}
                            className="row"
                            pickerClassName="col-md-4 form-group"
                            onStartDateChange={(moment) => this.handleStartDateChange(moment)}
                            onEndDateChange={(moment) => this.handleEndDateChange(moment)}
                            startDate={this.props.filterStartDate}
                            endDate={this.props.filterEndDate}
                        />
                    </FormGroup >
                </div>

                <div className="d-flex flex-row-reverse">
                    <FormGroup >
                        <Button className="bg-light-secondary"
                            onClick={() => this.goToNewDisbursementRequest()}>
                            Solicitar desembolso
                    </Button>
                    </FormGroup>
                </div>

                {this.props.disbursementRequestsData != null &&
                    <div>
                        {this.props.disbursementRequestsData.requests.length > 0 ?
                            <OgaTable
                                loading={this.state.loading}
                                headers={["Fecha", "Estado", "Descripción", "Monto($)"]}
                                properties={["date", "statusLabel", "description", "amount"]}
                                pullRight={[3]}
                                pageCount={this.props.disbursementRequestsData.count}
                                onPageChange={this.onPageChange}
                                values={this.props.disbursementRequestsData.requests}
                                actions={[
                                    {
                                        icon: "history",
                                        handler: this.handleShowHistory
                                    },
                                    {
                                        icon: "close",
                                        handler: this.handleAnnulment,
                                        show: this.handleShowAnnulment
                                    },
                                ]}
                            />
                            :
                            <NoInfo text="No tiene solicitudes de desembolso registradas" />
                        }
                    </div>
                }

                <DisbursementHistoryModal
                    history={this.props.history}
                    loading={this.state.loadingHistory}
                    disbursementId={this.state.disbursementId}
                    show={this.state.showHistoryModal}
                    onHide={() => this.setState({ showHistoryModal: false })}
                />

                <ConfirmModal
                    show={this.state.showAnnulmentModal}
                    loading={this.state.loadingAnnulment}
                    title="Anular Solicitud de Desembolso"
                    message="¿Está seguro de anular la solicitud de desembolso?"
                    disbursementId={this.state.disbursementId}
                    annul={(disbursementId) => this.annul(disbursementId)}
                    onHide={() => this.setState({ showAnnulmentModal: false })}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    disbursementRequestsData: state.disbursementrequest.data,
    status: state.disbursementrequest.filterStatus,
    filterStartDate: state.disbursementrequest.filterStartDate,
    filterEndDate: state.disbursementrequest.filterEndDate,
    history: state.disbursementrequest.history
});

export default connect(mapStateToProps,
    {
        fetchDisbursementRequests,
        updateFilterStatus,
        updateFilterStartDate,
        updateFilterEndDate,
        fetchDisbursementHistory,
        doAnnulment
    })(DisbursementRequestList);



// WEBPACK FOOTER //
// ./src/components/DisbursementRequestList/DisbursementRequestList.jsx